
import Vue from "vue";
import { Component } from "vue-property-decorator";
import IconButton from "@/components/UI/IconButton.vue";
import { configStore, uiStore } from "@/store/store-accessor";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon,
    Dropdown,
    IconButton
  }
})
export default class OxygenDropdown extends Vue {
  get backToAdmin() {
    if (configStore.documentSpecificNeededUrls) {
      return configStore.documentSpecificNeededUrls.backToWordPressUrl;
    }

    return "";
  }

  get backToDashboard() {
    return configStore.neededData?.adminUrl;
  }

  get settingsUrl() {
    return configStore.neededData?.breakdanceSettingsUrl;
  }

  openDesignLibrary() {
    uiStore.setDesignLibraryModalState(true);
  }

  openPreferencesModal() {
    uiStore.setPreferencesModalOpen(true);
  }
}
